/** Default WebSocket server for Scratch cloud variables in Nexus Blocks. */
export const NEXUS_CLOUD_HOST = 'wss://connectedwss.sync.nexus/';

/** Resolve cloud host from URL ?cloud_host= override or Nexus default. */
export const getCloudHost = () => {
    if (typeof location === 'undefined') {
        return NEXUS_CLOUD_HOST;
    }
    const override = new URLSearchParams(location.search).get('cloud_host');
    return override || NEXUS_CLOUD_HOST;
};
